import { Type } from "nanium/objects";

export class ServiceRequestHead {
	@Type(String) user?: string;
	@Type(String) password?: string;
	@Type(String) token?: string;
	@Type(String) language?: string;
	@Type(String) timezone?: string;
}
